import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ExpertAuth from "@/pages/ExpertAuth";

export const Route = createFileRoute("/expert-auth")({
  head: () => seoHead("/expert-auth"),
  component: ExpertAuth,
});
